import { render, staticRenderFns } from "./ListInvoices.vue?vue&type=template&id=cf65c3d4&scoped=true"
import script from "./ListInvoices.vue?vue&type=script&lang=ts"
export * from "./ListInvoices.vue?vue&type=script&lang=ts"
import style0 from "./ListInvoices.vue?vue&type=style&index=0&id=cf65c3d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf65c3d4",
  null
  
)

export default component.exports